import { Node_Type } from '@wix/ricos';
export function isCountableNode(node, { parents }) {
    return (node.type === Node_Type.LIST_ITEM ||
        (!parents.length &&
            node.type !== Node_Type.BULLETED_LIST &&
            node.type !== Node_Type.ORDERED_LIST));
}
//# sourceMappingURL=is-countable-node.js.map